<script>
import * as _ from 'lodash';
import { mapState } from 'vuex';

import config from '../config';

export default {
  install(Vue, options) {
    Vue.mixin({
      computed: {
        ...mapState('customerPii', ['customerPii']),
      },
      methods: {
        accountNumberRevealedPii(piiId) {
          return this.revealedPiiByType(piiId, 'accountNumber');
        },
        phoneNumberRevealedPii(piiId) {
          return this.revealedPiiByType(piiId, 'phoneNumber');
        },
        firstNameRevealedPii(piiId) {
          return this.revealedPiiByType(piiId, 'firstName');
        },
        lastNameRevealedPii(piiId) {
          return this.revealedPiiByType(piiId, 'lastName');
        },
        emailRevealedPii(piiId) {
          return this.revealedPiiByType(piiId, 'email');
        },
        revealedPiiByType(piiId, type) {
          if (!piiId) {
            return null;
          }
          const piiRecords = this.customerPii[type];
          const piiRecord = _.find(piiRecords, { piiId });
          if (!piiRecord) {
            if (config.get().showFallbackTextIfPiiUnavailable) {
              return `pii-unavailable (${piiId})`;
            }

            // TODO: go to error page
            throw new Error(`Didn't find pii value for piiId ${piiId}`);
          }
          return piiRecord.piiValue;
        },
      },
    });
  },
};
</script>
